import React from 'react';
import styled from 'styled-components';

import { ExtraBold } from './Text';
import { FONT } from '../../styles/color';

const TitleWrapper = styled.div`
	width: 100%;
	border-bottom: 3px solid ${ FONT.default };
	padding-bottom: 20px;
`;

export default function PageTitle(props) {
  return (
	<TitleWrapper style={ props.style }>
		<ExtraBold size='28px'>
			{props.children}
		</ExtraBold>
	</TitleWrapper>
  )
}
